import React from 'react';
import { UserData } from '@/portal/types/UserData.ts';

interface NotificationSettingsData {
  patientReferralEmailUsers: UserData[];
}

interface NotificationSettingsViewProps {
  data: NotificationSettingsData;
}

const NotificationSettingsView: React.FC<NotificationSettingsViewProps> = ({
  data,
}) => {
  return (
    <div>
      <div className="mb-3">
        <strong>Patient Referral Email Notifications:</strong>
        <div className="text-muted mt-2">
          {data.patientReferralEmailUsers.length === 0 ? (
            <em>No users configured to receive notifications</em>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {data.patientReferralEmailUsers.map((user) => (
                <span key={user.id} className="badge bg-secondary rounded-pill">
                  {user.firstName} {user.lastName}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingsView;
